
import React, { useEffect, useState } from 'react';
import { Users, Clock, MapPin } from 'lucide-react';

export const SocialProofWidget: React.FC = () => {
  const [liveCounter, setLiveCounter] = useState(127);
  const [recentActivity, setRecentActivity] = useState('');

  useEffect(() => {
    // Simulate live counter updates
    const interval = setInterval(() => {
      if (Math.random() < 0.3) {
        setLiveCounter(prev => prev + 1);
      }
    }, 15000);

    // Generate random recent activity
    const activities = [
      'Een productiebedrijf uit Amsterdam heeft zojuist energieanalyse afgerond',
      'Logistiek bedrijf in Rotterdam ontdekte 25% besparingspotentieel',
      'MKB-bedrijf uit Utrecht startte met zonnepanelen installatie',
      'Tech startup boekte adviesgesprek voor volgende week',
      'Groothandel uit Eindhoven implementeert energieopslag'
    ];

    const activityInterval = setInterval(() => {
      const randomActivity = activities[Math.floor(Math.random() * activities.length)];
      setRecentActivity(randomActivity);
    }, 8000);

    // Set initial activity
    setRecentActivity(activities[0]);

    return () => {
      clearInterval(interval);
      clearInterval(activityInterval);
    };
  }, []);

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 z-50">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 space-y-3">
        {/* Live counter */}
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
          <div className="flex items-center gap-2 text-sm">
            <Users className="w-4 h-4 text-gray-500" />
            <span className="font-medium text-gray-900">{liveCounter}</span>
            <span className="text-gray-600">bedrijven deden deze week de scan</span>
          </div>
        </div>

        {/* Recent activity */}
        {recentActivity && (
          <div className="flex items-start gap-3 pt-2 border-t border-gray-100">
            <Clock className="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" />
            <p className="text-xs text-gray-600 animate-fade-in">
              {recentActivity}
            </p>
          </div>
        )}

        {/* Success highlight */}
        <div className="bg-gradient-to-r from-energy-green/10 to-energy-blue/10 rounded-lg p-3">
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4 text-energy-green" />
            <span className="text-sm font-medium text-energy-green">
              Gemiddeld €18.500 besparing per jaar
            </span>
          </div>
          <p className="text-xs text-gray-600 mt-1">
            voor bedrijven die de aanbevelingen opvolgen
          </p>
        </div>
      </div>
    </div>
  );
};
